<template>
  <div class="bk-editable-field-contenteditable">
    <div
      ref="input"
      contenteditable
      @keydown.stop.capture="onKeyDown"
      @input="onInput"
      v-html="original"
    />
  </div>
</template>

<script setup>
import { ref, onMounted } from "#imports";
const props = defineProps({
  modelValue: { type: String, required: true },
  type: { type: null, required: true }
});
const original = ref("");
const emit = defineEmits(["update:modelValue", "close"]);
const onInput = (e) => {
  if (e.target instanceof HTMLElement) {
    emit("update:modelValue", e.target.innerHTML);
  }
};
const onKeyDown = (e) => {
  if (e.code === "Escape") {
    e.preventDefault();
    emit("close");
  }
};
onMounted(() => {
  original.value = props.modelValue;
});
</script>
